@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zhi+Mang+Xing&display=swap');
@import url('https://fontsapi.zeoseven.com/556/main/result.css');

@font-face {
  font-family: "The Peak Font Plus";
  src: url("/fonts/ThePeakFontPlus-Regular.ttf") format("truetype");
  font-style: normal;
  font-display: swap;
  font-weight: 400;
}

@font-face {
  font-family: "TW-MOE-Std-Kai";
  src: local("TW-MOE-Std-Kai"), local("BiauKai"), local("標楷體"), local("DFKai-SB"), url("https://dict.concised.moe.edu.tw/concised-dict.woff") format("woff");
  font-style: normal;
  font-display: swap;
  font-weight: 400;
}

@font-face {
  font-family: "演示夏行楷";
  src: url("/fonts/Slidexiaxing-Regular.ttf") format("truetype");
  font-style: normal;
  font-display: swap;
  font-weight: 400;
}

@font-face {
  font-family: "英椎行書";
  src: url("/fonts/YingZhuiXingShu.woff2") format("woff2");
  font-style: normal;
  font-display: swap;
  font-weight: 400;
}

@font-face {
  font-family: "正風毛筆字體";
  src: url("/fonts/MasaFont-Regular.woff2") format("woff2");
  font-style: normal;
  font-display: swap;
  font-weight: 400;
}



@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --edu-blue: #2563eb;
  --trace-orange: #f97316;
  --text: #374151;
  --text-h: #111827;
  --bg: #f9fafb;
  --border: #e5e7eb;
  --panel-bg: #ffffff;
  --shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --font-zitie: "The Peak Font Plus", "Noto Sans TC", "Noto Serif TC", serif;
}

.tianzig-char {
  font-family: var(--font-zitie);
}

body {
  margin: 0;
  font-family: "Noto Sans TC", system-ui, sans-serif;
  font-weight: normal;
  background: var(--bg);
  color: var(--text);
  -webkit-font-smoothing: antialiased;
}

#root {
  width: 100%;
  min-height: 100vh;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

@media print {
  /* 強制隱藏所有列印時不需要的設定選項、控制面板、標籤切換列、預覽工具列及輔助元件 */
  .print\:hidden,
  header,
  section,
  nav {
    display: none !important;
  }

  /* 強制清空所有可能帶有背景、邊框、陰影的外層包裝容器 */
  html, body, #root, main, aside, 
  aside > div, 
  aside > div > div {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
  }

  @page {
    margin: 0;
    size: auto;
  }

  /* Reset the container wrapper (畫布工作區) */
  .print-container {
    padding: 0 !important;
    margin: 0 !important;
    max-height: none !important;
    overflow: visible !important;
    background-color: white !important; /* 確保背景為純白 */
    background-image: none !important;   /* 強制移除點狀網格背景圖 */
    width: 100% !important;
    height: auto !important;
    display: block !important;
  }

  /* Reset outer layout styles to avoid scrolling or clipping */
  .print-wrapper {
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
    position: static !important;
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* The actual page sheet */
  .print-sheet {
    transform: none !important;
    position: static !important;
    box-shadow: none !important;
    border: none !important;
    margin: 0 !important;
    break-inside: avoid;
    page-break-inside: avoid;
    background: white !important;
  }

  .print-wrapper ~ .print-wrapper .print-sheet {
    break-before: page;
    page-break-before: always;
  }

  /* Ensure background and grid lines print exactly */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
